var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M30,60A30,30,0,1,1,60,30,30,30,0,0,1,30,60ZM30,3.27A26.73,26.73,0,1,0,56.72,30,26.75,26.75,0,0,0,30,3.27Z","key":0}),React.createElement("polygon",{"className":"cls-1","points":"31.72 18.74 29.41 21.06 36.71 28.36 17.94 28.36 17.94 31.63 36.71 31.63 29.41 38.93 31.72 41.25 42.98 29.99 31.72 18.74","key":1})]);
}

Arrow.defaultProps = {"id":"Capa_1","data-name":"Capa 1","viewBox":"0 0 59.99 59.99"};

module.exports = Arrow;

Arrow.default = Arrow;
